/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-fee-view',
  template: `
    <span *ngIf="fee?.type === 'PERCENTAGE'">{{ fee.percentage / 100 | percentage }}</span>
    <span *ngIf="fee?.type === 'MONETARY'">{{ fee.monetary | stat }}</span>
    <span *ngIf="fee?.type === 'MULTI_CURRENCY_MONETARY'">
      <span *ngFor="let ma of fee.multiCurrencyMonetaryAmounts; let last = last">{{ ma | stat }}<span *ngIf="!last">, </span></span>
    </span>
  `
})
export class TeamFeeComponent {
  @Input() fee: any;
}
